import { useSelector, useDispatch } from "react-redux";
import {
  openModal,
  closeModal,
  setSelectedMenuItem
} from "../../features/tableOfContents/TableOfContentsSlice";
import {isSameItem} from "./tableOfContents";

export function useTableOfContents() {
  const dispatch = useDispatch();
  const { isOpen, tableOfContents, activeItem } = useSelector(
    (state) => state.tableOfContents,
  );

  const isActiveItem = (item) => {
    return isSameItem(item, activeItem);
  }

  return {
    isOpen,
    tableOfContents,
    activeItem,
    openModal: () => dispatch(openModal()),
    closeModal: () => dispatch(closeModal()),
    setSelectedMenuItem: (item) => dispatch(setSelectedMenuItem(item)),
    isActiveItem,
  };
}
